import {atom} from 'jotai';

/** Number of page-level right drawers currently open (comments, privacy, etc.). */
export const pageDrawerOpenCountAtom = atom(0);

export const isPageDrawerOpenAtom = atom((get) => get(pageDrawerOpenCountAtom) > 0);
